export default "__VITE_ASSET__2f9a4cae__"